import Vue from "vue"
import VueRouter from "vue-router"

const paths = [
  {
    name: "signge",
    path: "/signage",
    component: () => import(/* webpackChunkName: "Signage" */ "@/pages/Signage/Signage"),
  },
]
Vue.use(VueRouter)

let routes = []

paths.forEach(page => {
  routes.push(page)
})

const router = new VueRouter({
  mode: "history",
  routes
})

export default router